import React from 'react';
import styled from '@emotion/styled';
import breakpoints from '../../theme/material/breakpoints';

interface PageWithFooterProps {
  customDesktopStyles?: React.CSSProperties;
  customMobileStyles?: React.CSSProperties;
}

const PageWithFooter = styled('div')<PageWithFooterProps>(({ customDesktopStyles, customMobileStyles }) => ({
  paddingBottom: 135,
  ...customDesktopStyles,
  [breakpoints.down('sm')]: {
    paddingBottom: 18,
    ...customMobileStyles,
  },
}));

export default PageWithFooter;
